<template>
  <div
    v-if="breadcrumbList"
    class="w-full pt-5 pb-0 pl-1 flex items-end text-md text-left border-b-0"
  >
    <a-icon
      type="home"
      theme="filled"
      class="my-auto ml-0 mr-2"
      aria-hidden="true"               
      :style="{ fontSize: '14px', color: '#415161' }"
    />
    <div
      class="text-xs md:text-sm mr-1"
      v-for="(breadcrumb, index) in breadcrumbList"
      :key="index"
    >
      <span
        :class="
          index != Object.keys(breadcrumbList).length - 1
            ? ''
            : 'font-semibold text-blue'
        "
      >
        <router-link v-if="breadcrumb.link" :to="breadcrumb.link">{{
          breadcrumb.label
        }}</router-link>
        <span v-else :to="breadcrumb.link">{{ breadcrumb.label }}</span>
        <span v-if="breadcrumb.param">
          {{ $route.query[breadcrumb.param] }}</span
        >
      </span>
      <span
        v-if="index != Object.keys(breadcrumbList).length - 1"
        class="mx-px"
      >
        /
      </span>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.initBreadcrumb();
    this.updated();
  },
  data() {
    return {
      breadcrumbList: [],
    };
  },
  methods: {
    initBreadcrumb() {
      if (
        this.$route.fullPath === "/" ||
        this.$route.fullPath === "/dashboard/home"
      )
        this.breadcrumbList = [{ label: "Inicio", link: "/" }];
      else {
        const routeBreadcrumb = this.$route?.meta?.breadcrumb;
        if (Array.isArray(routeBreadcrumb)) {
          // La ruta actual define su propia miga de pan: es la fuente de
          // verdad. No se reutiliza la guardada en el store para evitar
          // arrastrar un breadcrumb previo que no corresponde a esta ruta.
          this.breadcrumbList = routeBreadcrumb.map((item) => ({ ...item }));
        } else {
          // Respaldo: solo si la ruta no define breadcrumb, usar el del store.
          let breadcrumbListSession =
            this.$store.getters["session/getBreadcrumb"];
          this.breadcrumbList = Array.isArray(breadcrumbListSession)
            ? breadcrumbListSession.map((item) => ({ ...item }))
            : routeBreadcrumb;
        }

        if (this.breadcrumbList)
          this.breadcrumbList[this.breadcrumbList?.length - 1] = {
            label: this.breadcrumbList[this.breadcrumbList?.length - 1].label,
            link: this.$route.fullPath,
          };
      }
    },
    splitBreadcrumb() {
      let actualBreadcrumbList = [...this.$route?.meta?.breadcrumb];
      let newBreadcrumbList = [];
      // Asegurar que breadcrumbList sea un array válido
      if (
        this.breadcrumbList &&
        Array.isArray(this.breadcrumbList) &&
        this.breadcrumbList.length > 0 &&
        actualBreadcrumbList.length > 0
      ) {
        for (let index = 0; index < actualBreadcrumbList.length; index++) {
          if (
            actualBreadcrumbList[index].label ===
            this.breadcrumbList[index]?.label
          )
            newBreadcrumbList.push(this.breadcrumbList[index]);
          else
            newBreadcrumbList.push({
              label: actualBreadcrumbList[index].label,
              link: this.$route?.fullPath,
            });
        }
      } else if (actualBreadcrumbList.length > 0) {
        // Si breadcrumbList está vacío, usar actualBreadcrumbList directamente
        newBreadcrumbList = actualBreadcrumbList.map((item, index) => ({
          ...item,
          link: index === actualBreadcrumbList.length - 1 ? this.$route.fullPath : item.link
        }));
      }
      this.breadcrumbList = newBreadcrumbList;
    },
    updated() {
      this.$store.dispatch("session/updateBreadcrumb", this.breadcrumbList);
    },
    buildBreadcrumb() {
      if (this.$route.meta.breadcrumb) {
        let actualBreadcrumbList = [...this.$route?.meta?.breadcrumb];

        if (
          this.$route.fullPath === "/" ||
          this.$route.fullPath === "/dashboard/home" ||
          this.$route.fullPath === "/customer"
        ) {
          this.breadcrumbList = [{ label: "Inicio", link: "/" }];
        } else {
          // Asegurar que breadcrumbList sea un array
          if (!this.breadcrumbList || !Array.isArray(this.breadcrumbList)) {
            // Si breadcrumbList está vacío o es null/undefined, inicializar desde actualBreadcrumbList
            this.breadcrumbList = actualBreadcrumbList.map((item, index) => ({
              ...item,
              link: index === actualBreadcrumbList.length - 1 ? this.$route.fullPath : item.link
            }));
          } else {
            let breadcrumb = {
              label: actualBreadcrumbList[actualBreadcrumbList.length - 1].label,
              link: this.$route.fullPath,
            };
            // Verificar que breadcrumbList tenga elementos antes de acceder
            if (
              this.breadcrumbList.length > 0 &&
              this.breadcrumbList[this.breadcrumbList.length - 1].label ===
                breadcrumb.label
            ) {
              this.breadcrumbList[this.breadcrumbList.length - 1] = breadcrumb;
            } else {
              this.breadcrumbList.push(breadcrumb);
            }
            this.splitBreadcrumb();
          }
        }
      } else {
        this.breadcrumbList = null;
      }
    },
  },
  destroyed() {
    this.updated();
  },

  watch: {
    $route() {
      this.buildBreadcrumb();
      this.updated();
    },
  },
};
</script>